<form [formGroup]="inputForm" (ngSubmit)="onSubmit()" class="container">
    <mat-form-field>
        <mat-label>Tab Name</mat-label>
        <input matInput formControlName="Name" readonly>
    </mat-form-field>
    <div>
        <app-select-list name="Black List" [Selections]="blacklist" (changes)="onChangeBlackList($event)"></app-select-list>
    </div>
    <!-- <div>
        <button mat-button-raised>Save</button>
    </div> -->
</form>
